import { render, staticRenderFns } from "./ReceiptPaymentSideMenu.vue?vue&type=template&id=97e5270a"
import script from "./ReceiptPaymentSideMenu.vue?vue&type=script&lang=js"
export * from "./ReceiptPaymentSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e5270a')) {
      api.createRecord('97e5270a', component.options)
    } else {
      api.reload('97e5270a', component.options)
    }
    module.hot.accept("./ReceiptPaymentSideMenu.vue?vue&type=template&id=97e5270a", function () {
      api.rerender('97e5270a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/receiptpayment/ReceiptPaymentSideMenu.vue"
export default component.exports